import React, { useEffect } from "react";
import InvoiceList from "./InvoiceList";
import BillingInfo from "../Setting/Components/BillingLeftSide/Components/BillingInfo";
import MasterTemplate from "../../../App/views/MasterTemplate";
import { ROLE_PROPERTY_ADMIN_ID } from "../../../User/configs/Constants";
import {
  getBillingContactThunk,
  getBillingInfoThunk,
} from "../../thunks/BillingThunk";
import { useDispatch, useSelector } from "react-redux";
import { userCompanyChooseSelector } from "../../../User/selectors/UserSelectors";
import {
  billingContactSelector,
  billingInfoSelector,
} from "../../selectors/BillingSelector";
import BillingContact from "../Setting/Components/BillingLeftSide/Components/BillingContact";
import SizeBox from "../../../../components/SizeBox";
import ModalBillingContact from "../Setting/Components/ModalBillingContact";
import ModalAddCreditCard from "../Setting/Components/ModalAddCreditCard";
import ModalAddBillingContact from "../Setting/Components/ModalAddBillingContact";
import ModalBillingInformation from "../Setting/Components/ModalBillingInformation";
import {
  modalBillingContactAction,
  modalBillingInformationAction,
} from "../../actions/BiilingActions";

const PropertyInvoice = () => {
  const dispatch = useDispatch();
  const userCompanyChoose = useSelector(userCompanyChooseSelector);

  const billingInfo = useSelector(billingInfoSelector);
  const billingContact = useSelector(billingContactSelector);

  useEffect(() => {
    _getStaticContent();
  }, [userCompanyChoose]);

  const _getStaticContent = () => {
    dispatch<any>(getBillingInfoThunk());
    dispatch<any>(getBillingContactThunk());
  };

  const _openBillingInformation = () => {
    dispatch(modalBillingInformationAction(true));
  };

  const _openBillingContact = () => {
    dispatch(modalBillingContactAction(true));
  };

  return (
    <MasterTemplate roleAccept={[ROLE_PROPERTY_ADMIN_ID]}>
      <div className={"billing-tab"}>
        <div className={"billing-tab__left"}>
          <BillingInfo
            companyInfo={billingInfo}
            openBillingInformation={_openBillingInformation}
          />
          <BillingContact
            billingContact={billingContact}
            openBillingContact={_openBillingContact}
          />
        </div>
        <SizeBox width={"30px"} />
        <InvoiceList />
      </div>
      <ModalBillingContact />
      <ModalAddCreditCard />
      <ModalAddBillingContact />
      <ModalBillingInformation />
    </MasterTemplate>
  );
};

export default PropertyInvoice;
